import { SlColorsService } from './../../../services/sl-colors.service';
import { ColorBrewerService } from './../../../services/color-brewer.service';
import { Component, OnInit, OnDestroy, HostBinding, Pipe, PipeTransform, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ColorGenDialogService } from './color-gen-dialog.service';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { SLLayer, LayerTypeEnum } from 'src/app/model/sl-layer';
import { DictHandler, LayerAttributesArray, AttributeInfo, AttributeRequirement } from 'src/app/types/@types/sl-v-types';
import { HexString } from 'src/app/types/@types/hex-string';
import { EnvService } from 'src/app/env.service';
import { ClassificationService, ClassGeneratorModel } from 'src/app/model/api-services/classification.service';
import { LabelStyle } from 'src/app/types/LabelStyle';
import { ColorClassification } from 'src/app/types/color-classification';


@Component({
  selector: 'app-color-gen-dialog-entry',
  templateUrl: './color-gen-dialog.component.html',
  styleUrls: ['./color-gen-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorGenDialogEntryComponent implements AfterViewInit {

  @HostBinding('class.work-view') workView = true;
  public layer: SLLayer;
  public attributes: LayerAttributesArray = [];
  public hasLayer = false;

  public method: 'unique' | 'equalinterval' | 'diverging' | 'custom' | 'quantile' | 'single' = 'custom';
  public attribute = '';
  public useStroke = true;
  public stroke: HexString | string = '#000000';
  public fill: HexString | string = '#FFFFFF';
  public useFill = true;

  public swatchSrc = '';
  public geom = '';
  public symbol = '';
  public size = 2;
  public type = '';
  public labelStyle: LabelStyle = '';
  public steps = '';

  public attributeReady = false;
  public useLabelStyle = true;
  public mediaURL: string;
  public showAttributes = false;
  public useFillPicker = true;
  public useFillColor = true;
  public useBrewerColors = false;
  public uniqueRamp = '';
  public useUniqueRamp = false;
  public uniqueRampURL = '';
  public uniqueColors: Array<string> = [];
  public colorsSource: Array<any> = [];
  public currentColor: any = [];
  public currentType: Array<any> = [];
  public hasType = false;
  public currentSteps: Array<any>;
  public hasSteps = false;
  public colorRamps: Array<any>;
  public rampColors: Array<string> = [];
  public hasRamps = false;
  public ramp = '';
  public rampURL = '';

  public attributeExclusions: Array<string> = [];
  private handler: DictHandler;
  private _ready = false;
  public isValid = false;


  public get displayColors(): boolean {
    if (!this.attributeReady) return false;
    return (this.useBrewerColors || this.useUniqueRamp)
  }

  constructor(
    private env: EnvService,
    private classSvc: ClassificationService,
    private colorSvc: ColorBrewerService,
    private slColorsSvc: SlColorsService,
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef) {
    this.mediaURL = env.baseHRef + 'assets/images/colorbrewer/';


  }

  ngAfterViewInit(): void {
    this._ready;
    this.hasLayer = (this.layer !== undefined);
    this.method = 'single';
    this.ShowMethod();

  }

  ShowMethod() {
    this.useBrewerColors = false;
    this.currentColor = [];
    this.hasSteps = false;
    this.hasRamps = false;
    this.useFillPicker = false;
    this.useUniqueRamp = false;
    this.showAttributes = false;
    this.attributeExclusions = [];
    this.attribute = '';
    this.stroke = '#000000';
    this.fill = '#ffffff';
    switch (this.method) {

      case 'single':
        this.useFillPicker = this.layer.geom !== 'line';
        this.useFillColor = this.useFillPicker;
        this.useUniqueRamp = false;
        this.useBrewerColors = false;
        this.showAttributes = false;
        this.attributeReady = true;
        this.attributeExclusions = [];
        break;
      case 'unique':
        this.useFillPicker = false;
        this.useFillColor = this.useFillPicker;
        this.currentColor = this.classSvc.GetUniqueColors();
        this.useBrewerColors = false;
        this.useUniqueRamp = true;
        this.showAttributes = true;
        this.attributeReady = false;
        this.attributeExclusions = [];
        break;
      case 'equalinterval':
      case 'quantile':
        this.useFillPicker = false;
        this.useFillColor = this.useFillPicker;
        this.useUniqueRamp = false;
        this.currentColor = this.classSvc.GetColorTypes();
        this.useBrewerColors = true;
        this.showAttributes = true;
        this.hasSteps = false;
        this.hasRamps = false;
        this.attributeReady = false;
        this.attributeExclusions = ['numeric'];
        break;

    }
    this.Validate();
    this.Refresh();
  }
  ShowAttribute() {
    this.attributeReady = this.attribute !== '';
    this.Validate();
    this.Refresh();

  }
  ShowType(steps: Array<any>) {
    this.currentSteps = steps;
    this.steps = '';
    this.hasSteps = this.type !== '';
    this.hasRamps = false;
    this.rampURL = '';
    this.rampColors = [];
    this.Validate();
    this.Refresh();


  }
  ShowSteps(ramps: Array<any>) {
    this.colorRamps = ramps;
    this.rampURL = '';
    this.hasSteps = true;
    this.hasRamps = true;
    this.ramp = '';
    this.rampColors = [];
    this.Validate();
    this.Refresh();
  }
  UpdateUniqueRamp() {
    if (this.uniqueRamp === '') {
      this.uniqueRampURL = '';
      this.uniqueColors = [];
    } else {
      this.uniqueRampURL = this.mediaURL + this.uniqueRamp.split('_').shift() + '.png';
      this.uniqueColors = this.slColorsSvc.GetColors(this.uniqueRamp.split('_').shift());
    }
    this.Validate();
    this.Refresh();
  }

  ShowRamp() {
    if ([this.ramp, this.currentColor, this.steps].indexOf('') > -1) {
      this.rampURL = '';
      this.rampColors = [];
    } else {
      this.rampURL = this.mediaURL + this.ramp.split('_').shift() + '.png';
      this.rampColors = ColorBrewerService.GetPaletteColors(this.currentColor[Number(this.type)].label, this.currentSteps[this.steps].label, this.ramp.split('_').shift());
    }
    this.Validate();
    this.Refresh();
  }

  Show(args: any) {

    this.handler = args.handler;
    this.layer = args.layer;
    this.swatchSrc = this.env.baseHRef + 'assets/empty.png';
    this.attributes = this.layer.layerAttributes;

    this.attribute = this.layer.data.classification.attribute;
    this.method = this.layer.data.classification.type;

    this.useStroke = this.layer.data.classification.stroke_color !== 'trans';
    if (this.layer.data.classification.stroke_color.substr(0, 1) !== '#') {
      this.stroke = this.useStroke ? '#000000' : '#cccccc';
    } else {
      this.stroke = this.useStroke ? this.layer.data.classification.stroke_color : '#cccccc';
    }
    this.useFill = this.layer.data.classification.fill_color !== 'trans';
    if (this.layer.data.classification.fill_color.substr(0, 1) !== '#') {
      this.fill = this.useStroke ? '#000000' : '#cccccc';
    } else {
      this.fill = this.useStroke ? this.layer.data.classification.stroke_color : '#cccccc';
    }

    this.symbol = this.layer.data.classification.symbol;
    this.size = this.layer.data.classification.symbol_size;
    this.geom = this.layer.geom;

    this.labelStyle = this.layer.labelStyle;
    this.useLabelStyle = this.labelStyle !== '';
    this.hasLayer = true;

    const fillInfo = this.fill.split('_');
    if (this.method !== 'custom') {
      switch (fillInfo.length) {
        case 1:
          this.useFillPicker = true;
          this.useBrewerColors = false;
          this.useUniqueRamp = false;
          this.currentColor = [];
          break;
        case 3:
          this.currentColor = this.classSvc.GetColorTypes();
          this.type = fillInfo[2];
          this.steps = fillInfo[1];
          this.useFillPicker = false;
          if (this.type === 'unique') {
            this.currentColor = this.classSvc.GetUniqueColors();
            this.uniqueRamp = fillInfo[0];
            this.uniqueRampURL = this.mediaURL + this.uniqueRamp + '.png';
            this.useUniqueRamp = true;
            this.useBrewerColors = false;
          } else {
            this.ramp = fillInfo[0];
            this.currentColor = this.classSvc.GetColorTypes();
            for (const type of this.currentColor.label) {
              if (this.type === type.label) {
                this.currentSteps = type.data;
                for (const step of this.currentSteps) {
                  if (step.label === this.steps) {
                    this.colorRamps = step.data;
                    break;
                  }
                }
                break;
              }
            }
          }
          this.rampURL = this.mediaURL + this.ramp + '.png';
          this.useFillPicker = true;
          this.useBrewerColors = false;

          this.useBrewerColors = false;
          this.useUniqueRamp = true;
          break;
      }
    }
    if (this.attribute === null) {
      this.attribute = '';
    }
    this.Validate();
    this.Refresh();
  }
  HandleButtonOne() {
    this.GenerateRules();
    this.activeModal.close();
  }
  HandleButtonTwo() {
    this.activeModal.close();
  }
  GenerateRules() {
    let fill = this.fill;
    if (this.useBrewerColors === true) {
      fill = this.ramp;
    } else if (this.useUniqueRamp === true) {
      fill = this.uniqueRamp;
    }
    let stroke = this.stroke;
    if (this.geom === 'line') {
      stroke = fill;
    }

    const request: ClassGeneratorModel = {
      colorscheme: this.method,
      fill_color: fill,
      stroke_color: stroke,
      label_style: this.labelStyle,
      plid: Number(this.layer.plid),
      symbol: this.symbol,
      symbol_size: this.size

    };
    if (['custom', 'single'].indexOf(this.method) === -1) {
      request.attribute = this.attribute;
    }
    this.classSvc.GenerateClasses(request).then((classificaiton: ColorClassification) => {
      this.handler(classificaiton);
    });
  }
  LabelStyleChanged() {
    this.useLabelStyle = this.labelStyle !== '';
    this.Refresh();
  }

  Validate() {
    let isValid = false;
    switch (this.method) {
      case 'custom':
        isValid = false;
        break;
      case 'single':
        isValid = this.useFillPicker && (this.fill.indexOf('#') === 0);
        break;
      case 'unique':
        isValid = this.attributeReady;
        isValid = isValid && this.useUniqueRamp && (this.uniqueRampURL !== '');
        break;
      default:
        isValid = this.attributeReady;
        isValid = isValid && this.useBrewerColors && (this.rampURL !== '');
        break;

    }
    this.isValid = isValid;
  }
  IsDisplayableAttribute(attType: string) {
    return this.attributeExclusions.indexOf(attType) > -1;
  }
  IsNumeric(attribute: AttributeInfo): boolean {
    const requirement: AttributeRequirement = attribute.requires;
    const type = attribute.type;
    if(!!requirement) {
      return ['float', 'int', 'integer', 'real', 'numeric'].indexOf(requirement) > -1;
    }
    return ['float', 'int', 'integer', 'real', 'numeric'].indexOf(type) > -1;

  }
  Refresh() {
    if (!!this._ready) {
      this.cdr.detectChanges();
    }
  }
}

@Component({
  selector: 'app-color-gen-dialog',
  template: ''
})
export class ColorGenDialogComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: ColorGenDialogService) {

    this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
      this.modalRef = this.modalService.open(ColorGenDialogEntryComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as ColorGenDialogEntryComponent).Show(info);
    });
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }

}


@Pipe({
  name: 'conditionalAttType',
  pure: true
})
export class ConditionalAttTypePipe implements PipeTransform {
  transform(value: string, filters: Array<any>): boolean {
    return filters.indexOf(value) > -1;
  }

}
